import { FC } from 'react';
import styled from './index.module.scss';
import NextImage from '@/components/NextImage';
import { Button } from '@/components/UI';
import { useGlobal } from '@/utils/useGlobal';
import { CommunityUrl } from '@/constants/referral';

const JoinUs: FC = ({}) => {
    const { useLang, isMobile, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');

    const arr = [t('joinus.desc1'), t('joinus.desc2'), t('joinus.desc3')];

    return (
        <div className={`${styled.join_us}`}>
            <NextImage src={require(`@publicLocal/referral/${isMobile ? 'h5' : 'pc'}/community.jpg`)} alt={t('joinus.title')} aria-label={t('joinus.title')} />
            <div className="join_us_text">
                <h1 className="title">{t('joinus.title')}</h1>
                <ul className="subtitle">
                    {arr.map((item) => (
                        <li key={item}>{item}</li>
                    ))}
                </ul>
                <Link href={CommunityUrl[locale] || CommunityUrl.eu} traget="_blank">
                    <Button className="refer-btn white" onClick={() => console.log('benefits')} aria-label={t('benefits.btn')}>
                        {t('joinus.btn')}
                    </Button>
                </Link>
            </div>
        </div>
    );
};

export default JoinUs;
